export interface EmpresaConfig {
  id: string; // 'matriz', 'filial_two', ou id gerado
  is_padrao?: boolean;
  razao_social: string;
  nome_fantasia: string;
  cnpj: string;
  inscricao_estadual?: string;
  inscricao_municipal?: string;
  rntrc_antt?: string; // Registro Nacional de Transportadores Rodoviários de Cargas
  cnae_principal?: string;
  regime_tributario?: 'simples_nacional' | 'lucro_presumido' | 'lucro_real' | 'mei' | 'outros';
  
  // Identidade Visual
  logo_url?: string;
  logo_dark_url?: string;
  favicon_url?: string;

  // Comunicação & Contatos
  telefone: string;
  whatsapp: string;
  email: string;
  email_financeiro?: string;
  email_operacional?: string;
  website?: string;

  // Endereço
  cep: string;
  logradouro: string;
  numero: string;
  complemento?: string;
  bairro: string;
  cidade: string;
  uf: string;
  codigo_ibge?: string;

  // Dados Financeiros & Pagamento
  banco_padrao?: string;
  agencia?: string;
  conta_corrente?: string;
  chave_pix?: string;
  tipo_chave_pix?: 'cnpj' | 'email' | 'telefone' | 'aleatoria';
  titular_conta?: string;

  // Responsável Legal / Operacional
  responsavel_nome?: string;
  responsavel_cargo?: string;
  responsavel_cpf?: string;
  responsavel_telefone?: string;

  // Textos para Documentos
  observacoes_padrao?: string;
  rodape_documentos?: string;

  created_at?: string;
  updated_at?: string;
}

export const EMPRESA_PADRAO_INICIAL: EmpresaConfig = {
  id: 'rg_da_silva',
  is_padrao: true,
  razao_social: 'R.G DA SILVA TRANSPORTES',
  nome_fantasia: 'R.G DA SILVA',
  cnpj: '40.280.899/0001-68',
  inscricao_estadual: '142.890.123.110',
  inscricao_municipal: '5.891.204-1',
  rntrc_antt: '58492014',
  cnae_principal: '49.30-2-02 - Transporte rodoviário de carga, exceto produtos perigosos e mudanças, intermunicipal, interestadual e internacional',
  regime_tributario: 'simples_nacional',
  
  logo_url: '',
  
  telefone: '(11) 94711-5843',
  whatsapp: '(11) 94711-5843',
  email: 'contato@voope.com.br',
  email_financeiro: 'financeiro@voope.com.br',
  email_operacional: 'operacional@voope.com.br',
  website: 'https://voope.com.br',

  cep: '03131-010',
  logradouro: 'Vila Prudente',
  numero: 'S/N',
  complemento: '',
  bairro: 'Vila Prudente',
  cidade: 'São Paulo',
  uf: 'SP',
  codigo_ibge: '3550308',

  banco_padrao: 'Banco do Brasil',
  agencia: '1234-5',
  conta_corrente: '98765-4',
  chave_pix: '40.280.899/0001-68',
  tipo_chave_pix: 'cnpj',
  titular_conta: 'R.G DA SILVA TRANSPORTES',

  responsavel_nome: 'Rafael Gonçalves da Silva',
  responsavel_cargo: 'Diretor Geral',
  responsavel_telefone: '(11) 94711-5843',

  observacoes_padrao: 'Transporte rodoviário de cargas fracionadas e dedicadas com rastreamento 24h e seguro de carga.',
  rodape_documentos: 'R.G DA SILVA • CNPJ: 40.280.899/0001-68 • Tel/WhatsApp: (11) 94711-5843 • www.voope.com.br'
};

export const EMPRESA_TWO_INICIAL: EmpresaConfig = {
  id: 'voope_two',
  is_padrao: false,
  razao_social: 'VOOPE TWO TRANSPORTES E CARGAS LTDA',
  nome_fantasia: 'VOOPE TWO',
  cnpj: '65.477.604/0001-79',
  inscricao_estadual: '149.231.847.112',
  inscricao_municipal: '6.120.455-8',
  rntrc_antt: '61902482',
  cnae_principal: '49.30-2-02 - Transporte rodoviário de carga, exceto produtos perigosos e mudanças, intermunicipal, interestadual e internacional',
  regime_tributario: 'simples_nacional',
  
  logo_url: '',
  
  telefone: '(11) 4710-3560',
  whatsapp: '(11) 4710-3560',
  email: 'two@voope.com.br',
  email_financeiro: 'financeiro.two@voope.com.br',
  email_operacional: 'operacional@voope.com.br',
  website: 'https://voope.com.br',

  cep: '09750-730',
  logradouro: 'Rua José Versolato',
  numero: '111',
  complemento: 'Bloco B Sala 3102',
  bairro: 'Centro',
  cidade: 'São Bernardo do Campo',
  uf: 'SP',
  codigo_ibge: '3548708',

  banco_padrao: 'BTG Pactual',
  agencia: '0001',
  conta_corrente: '124982-1',
  chave_pix: '65.477.604/0001-79',
  tipo_chave_pix: 'cnpj',
  titular_conta: 'VOOPE TWO TRANSPORTES E CARGAS LTDA',

  responsavel_nome: 'Rafael Gonçalves da Silva',
  responsavel_cargo: 'Sócio-Administrador',
  responsavel_telefone: '(11) 4710-3560',

  observacoes_padrao: 'Operações de transporte dedicadas e agregados Voope Two com cobertura securitária integral.',
  rodape_documentos: 'VOOPE TWO • CNPJ: 65.477.604/0001-79 • Tel/WhatsApp: (11) 4710-3560'
};
